import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appDivider]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppDividerDirective {
  #base = 'w-full border-t border-gray-200';
  class = input<string>();

  public styles = computed(() => {
    return cn(this.#base, this.class());
  });
}
